// extracted by mini-css-extract-plugin
export default {"container":"Meals_container__Wyzey"};